export const sequences2032 = [
  ['are', 'year', 'layer', 'really'],
  ['ear', 'care', 'recap', 'preach'],
  ['ate', 'tale', 'table', 'battle'],
  ['tea', 'seat', 'haste', 'chaste'],
  ['eat', 'tear', 'crate', 'racket'],
  ['are', 'fear', 'safer', 'faster'],
  ['ear', 'bare', 'bread', 'badger'],
  ['ate', 'east', 'stale', 'slater'],
  ['tea', 'late', 'alert', 'albert'],
  ['eat', 'heat', 'heath', 'health'],
  ['are', 'earn', 'range', 'danger'],
  ['ear', 'earl', 'pearl', 'player'],
  ['ate', 'rate', 'stare', 'breast'],
  ['tea', 'take', 'skate', 'casket'],
  ['eat', 'date', 'tread', 'dreamt'],
  ['are', 'earl', 'layer', 'lawyer'],
  ['ear', 'rate', 'water', 'wreath'],
  ['ate', 'late', 'alter', 'learnt'],
  ['tea', 'seat', 'tesla', 'stable'],
  ['eat', 'tale', 'alter', 'travel'],
  ['are', 'rage', 'grave', 'garvey'],
  ['ear', 'rate', 'react', 'create'],
  ['ate', 'east', 'least', 'stable'],
  ['tea', 'seat', 'waste', 'wasted'],
  ['eat', 'east', 'least', 'stable'],
  ['are', 'tear', 'water', 'watery'],
  ['ear', 'real', 'alert', 'albert'],
  ['ate', 'fate', 'feast', 'safest'],
  ['tea', 'east', 'stale', 'slater'],
  ['eat', 'late', 'tesla', 'stella'],
  ['are', 'bear', 'amber', 'marble'],
  ['ear', 'rage', 'grate', 'triage'],
  ['ate', 'tale', 'dealt', 'talked'],
  ['tea', 'team', 'matey', 'steamy'],
  ['eat', 'meat', 'mater', 'market'],
  ['are', 'read', 'dread', 'ladder'],
  ['ear', 'hear', 'reach', 'charge'],
  ['ate', 'tale', 'metal', 'mental'],
  ['tea', 'seat', 'feast', 'faster'],
  ['eat', 'tale', 'metal', 'mental'],
  ['are', 'hear', 'heart', 'father'],
  ['ear', 'bear', 'amber', 'marble'],
  ['ate', 'date', 'fated', 'defeat'],
  ['tea', 'take', 'taken', 'tanker'],
  ['eat', 'seat', 'yeast', 'stayed'],
  ['are', 'read', 'bread', 'barbed'],
  ['ear', 'gear', 'grate', 'target'],
  ['ate', 'seat', 'tease', 'seated'],
  ['tea', 'seat', 'yeast', 'stayed'],
  ['eat', 'tear', 'heart', 'breath'],
  ['are', 'bare', 'bread', 'badger'],
  ['ear', 'tear', 'later', 'albert'],
  ['ate', 'tear', 'water', 'wreath'],
  ['tea', 'east', 'paste', 'staple'],
  ['eat', 'heat', 'cheat', 'chalet'],
  ['are', 'earl', 'early', 'really'],
  ['ear', 'dear', 'tread', 'dreamt'],
  ['ate', 'late', 'dealt', 'talked'],
  ['tea', 'tear', 'mater', 'matter'],
  ['eat', 'team', 'metal', 'hamlet'],
  ['are', 'earn', 'raven', 'tavern'],
  ['ear', 'fear', 'safer', 'faster'],
  ['ate', 'east', 'waste', 'sweaty'],
  ['tea', 'meat', 'metal', 'mantle'],
  ['eat', 'tale', 'alert', 'taller'],
  ['are', 'near', 'yearn', 'nearly'],
  ['ear', 'race', 'crate', 'carpet'],
  ['ate', 'tape', 'taped', 'tapped'],
  ['tea', 'rate', 'trade', 'dreamt'],
  ['eat', 'east', 'beast', 'breast'],
  ['are', 'tear', 'eater', 'easter'],
  ['ear', 'dare', 'drake', 'marked'],
  ['ate', 'late', 'table', 'battle'],
  ['tea', 'neat', 'eaten', 'beaten'],
  ['eat', 'mate', 'steam', 'steamy'],
  ['pet', 'tape', 'paste', 'staple'],
  ['nap', 'snap', 'pansy', 'snappy'],
  ['sea', 'seal', 'lease', 'asleep'],
  ['red', 'ride', 'drive', 'driver'],
  ['net', 'neat', 'agent', 'eating'],
  ['sat', 'east', 'tease', 'senate'],
  ['the', 'thee', 'three', 'heater'],
  ['sit', 'site', 'suite', 'suited'],
  ['lie', 'live', 'olive', 'violet'],
  ['too', 'boot', 'boost', 'boston'],
  ['sat', 'east', 'asset', 'assert'],
  ['ale', 'male', 'metal', 'mental'],
  ['tie', 'site', 'suite', 'tissue'],
  ['lee', 'else', 'lease', 'asleep'],
  ['bow', 'bowl', 'bowel', 'bowled'],
  ['pan', 'snap', 'pansy', 'snappy'],
  ['ram', 'mark', 'maker', 'market'],
  ['lie', 'life', 'rifle', 'relief'],
  ['red', 'dear', 'armed', 'marked'],
  ['sea', 'seat', 'steam', 'stream'],
  ['net', 'tone', 'stone', 'stoned'],
  ['and', 'band', 'brand', 'brandy'],
  ['rat', 'star', 'start', 'artist'],
  ['red', 'ride', 'bride', 'bridge'],
  ['sat', 'seat', 'tesla', 'salute'],
  ['air', 'liar', 'frail', 'fairly'],
  ['art', 'rate', 'eater', 'repeat'],
  ['bad', 'brad', 'board', 'aboard'],
  ['cap', 'pace', 'recap', 'carpet'],
  ['sat', 'east', 'stale', 'salute'],
  ['car', 'race', 'crane', 'carmen'],
  ['tap', 'part', 'tramp', 'armpit'],
  ['set', 'east', 'state', 'statue'],
  ['sea', 'safe', 'feast', 'safety'],
  ['red', 'ride', 'fired', 'friend'],
  ['new', 'when', 'wench', 'wrench'],
  ['hat', 'bath', 'bathe', 'bertha'],
  ['fee', 'free', 'refer', 'prefer'],
  ['sit', 'fist', 'first', 'strife'],
  ['red', 'dear', 'beard', 'barbed'],
  ['sea', 'seat', 'tease', 'seated'],
  ['aid', 'laid', 'ideal', 'detail'],
  ['art', 'rate', 'mater', 'market'],
  ['led', 'lied', 'field', 'failed'],
  ['rat', 'tear', 'eater', 'easter'],
  ['nut', 'unit', 'unite', 'united'],
  ['she', 'shoe', 'horse', 'shower'],
  ['set', 'seat', 'beast', 'basket'],
  ['ain', 'nail', 'plain', 'alpine'],
  ['art', 'rate', 'after', 'father'],
  ['car', 'carl', 'clear', 'marcel'],
  ['let', 'left', 'flute', 'futile'],
  ['set', 'seat', 'feast', 'faster'],
  ['old', 'loud', 'aloud', 'unload'],
  ['may', 'maya', 'mayan', 'layman'],
  ['car', 'cart', 'craft', 'crafty'],
  ['ray', 'year', 'layer', 'lawyer'],
  ['set', 'sent', 'stein', 'listen'],
  ['sea', 'sale', 'steal', 'stella'],
  ['aid', 'maid', 'admit', 'dammit'],
  ['rid', 'bird', 'bride', 'buried'],
  ['her', 'hear', 'heard', 'harder'],
  ['due', 'rude', 'ruled', 'louder'],
  ['ray', 'year', 'yearn', 'nearby'],
  ['red', 'dare', 'cedar', 'carved'],
  ['car', 'cart', 'chart', 'starch'],
  ['ain', 'rain', 'drain', 'daring'],
  ['nor', 'torn', 'intro', 'orient'],
  ['our', 'tour', 'turbo', 'burton'],
  ['let', 'tale', 'least', 'latest'],
  ['ten', 'nest', 'tense', 'resent'],
  ['con', 'corn', 'corny', 'crayon'],
  ['one', 'note', 'noted', 'stoned'],
  ['bet', 'beth', 'bathe', 'bertha'],
  ['eve', 'ever', 'verse', 'severe'],
  ['art', 'tear', 'treat', 'target'],
  ['ace', 'cake', 'creak', 'packer'],
  ['die', 'tied', 'timed', 'midget'],
  ['met', 'mate', 'tamed', 'teamed'],
  ['log', 'long', 'logan', 'gallon'],
  ['red', 'read', 'adore', 'adored'],
  ['old', 'hold', 'holed', 'behold'],
  ['pro', 'drop', 'proud', 'poured'],
  ['son', 'soon', 'spoon', 'poison'],
  ['lie', 'line', 'lined', 'linked'],
  ['ace', 'face', 'faced', 'facade'],
  ['mad', 'made', 'tamed', 'dreamt'],
  ['don', 'down', 'drown', 'onward'],
  ['car', 'carl', 'coral', 'oracle'],
  ['rid', 'ride', 'fired', 'friend'],
  ['eat', 'date', 'acted', 'traced'],
  ['air', 'fair', 'friar', 'fairer'],
  ['see', 'seed', 'dense', 'sensed'],
  ['bro', 'bore', 'sober', 'somber'],
  ['her', 'hero', 'horse', 'shower'],
  ['rob', 'born', 'robin', 'boring'],
  ['bar', 'bare', 'break', 'bakery'],
  ['all', 'ball', 'label', 'ballet'],
  ['sea', 'east', 'state', 'statue'],
  ['tie', 'bite', 'tribe', 'bitter'],
  ['web', 'blew', 'elbow', 'blower'],
  ['pro', 'rope', 'roper', 'report'],
  ['sir', 'sire', 'risen', 'senior'],
  ['sea', 'same', 'amuse', 'assume'],
  ['end', 'done', 'drone', 'yonder'],
  ['nah', 'than', 'chant', 'snatch'],
  ['pro', 'rope', 'prove', 'proved'],
  ['tap', 'trap', 'tramp', 'tamper'],
  ['see', 'ease', 'lease', 'please'],
  ['art', 'tear', 'great', 'gather'],
  ['she', 'shed', 'shade', 'shared'],
  ['nor', 'corn', 'scorn', 'censor'],
  ['car', 'care', 'brace', 'breach'],
  ['red', 'read', 'cedar', 'scared'],
  ['rip', 'pair', 'pilar', 'pillar'],
  ['tie', 'tire', 'their', 'either'],
  ['sat', 'east', 'caste', 'stance'],
  ['car', 'race', 'grace', 'charge'],
  ['her', 'hear', 'harem', 'hammer'],
  ['tom', 'most', 'storm', 'stormy'],
  ['cat', 'cart', 'crate', 'carpet'],
  ['sat', 'seat', 'skate', 'casket'],
  ['set', 'rest', 'crest', 'escort'],
  ['lad', 'lead', 'pedal', 'placed'],
  ['red', 'read', 'grade', 'agreed'],
  ['but', 'bust', 'burst', 'buster'],
  ['tie', 'tire', 'merit', 'metric'],
  ['set', 'seat', 'steak', 'casket'],
  ['rat', 'cart', 'craft', 'crafty'],
  ['per', 'rope', 'roper', 'report'],
  ['act', 'chat', 'catch', 'catchy'],
  ['cat', 'cart', 'actor', 'carrot'],
  ['art', 'tear', 'mater', 'matter'],
  ['bow', 'blow', 'bowel', 'wobble'],
  ['ain', 'rain', 'train', 'martin'],
  ['end', 'tend', 'trend', 'tender'],
  ['tie', 'diet', 'tried', 'direct'],
  ['ran', 'earn', 'yearn', 'nearly'],
  ['our', 'tour', 'route', 'detour'],
  ['con', 'corn', 'scorn', 'censor'],
  ['pay', 'pray', 'party', 'partly'],
  ['fat', 'flat', 'fatal', 'afloat'],
  ['lad', 'dial', 'laird', 'bridal'],
  ['art', 'part', 'strap', 'pastor'],
  ['net', 'tone', 'atone', 'donate'],
  ['war', 'warn', 'rowan', 'narrow'],
  ['red', 'read', 'dream', 'marked'],
  ['act', 'cast', 'costa', 'mascot'],
  ['pro', 'drop', 'pedro', 'period'],
  ['net', 'note', 'monte', 'moment'],
  ['led', 'lied', 'filed', 'filled'],
  ['bow', 'bowl', 'elbow', 'bowler'],
  ['age', 'gate', 'grate', 'gather'],
  ['met', 'mate', 'meant', 'magnet'],
  ['tip', 'pity', 'tipsy', 'pigsty'],
  ['men', 'name', 'means', 'seaman'],
  ['got', 'goat', 'gator', 'bogart'],
  ['net', 'nest', 'stern', 'unrest'],
  ['art', 'cart', 'craft', 'crafty'],
  ['sat', 'seat', 'waste', 'wasted'],
  ['ham', 'harm', 'harem', 'hammer'],
  ['set', 'east', 'tease', 'estate'],
  ['yen', 'envy', 'envoy', 'convey'],
  ['bat', 'beat', 'beast', 'stable'],
  ['sat', 'stay', 'hasty', 'trashy'],
  ['nor', 'torn', 'north', 'throne'],
  ['lap', 'pale', 'plead', 'played'],
  ['net', 'rent', 'stern', 'insert'],
  ['car', 'race', 'react', 'create'],
  ['led', 'fled', 'field', 'filled'],
  ['nor', 'torn', 'snort', 'strong'],
  ['own', 'worn', 'drown', 'downer'],
  ['ain', 'gain', 'liang', 'signal'],
  ['ten', 'rent', 'trend', 'turned'],
  ['sea', 'east', 'feast', 'safest'],
  ['ace', 'care', 'crane', 'cancer'],
  ['sec', 'case', 'caste', 'aspect'],
  ['car', 'care', 'cared', 'sacred'],
  ['red', 'dear', 'cedar', 'sacred'],
  ['net', 'neat', 'eaten', 'beaten'],
  ['ace', 'case', 'caste', 'aspect'],
  ['raw', 'wear', 'water', 'waiter'],
  ['pal', 'pale', 'lapse', 'asleep'],
  ['end', 'send', 'sedan', 'ascend'],
  ['rat', 'tear', 'alert', 'travel'],
  ['set', 'site', 'suite', 'tissue'],
  ['aid', 'idea', 'aside', 'advise'],
  ['pal', 'pale', 'plate', 'planet'],
  ['man', 'mean', 'meant', 'mental'],
  ['ace', 'race', 'crave', 'carved'],
  ['bit', 'bite', 'tribe', 'bitter'],
  ['red', 'drew', 'weird', 'wilder'],
  ['pal', 'palm', 'ample', 'palmer'],
  ['aid', 'raid', 'rabid', 'bridal'],
  ['the', 'beth', 'bathe', 'bertha'],
  ['fat', 'fast', 'feast', 'faster'],
  ['yep', 'type', 'petty', 'pretty'],
  ['sit', 'this', 'shirt', 'thirst'],
  ['led', 'lied', 'lived', 'drivel'],
  ['try', 'troy', 'story', 'shorty'],
  ['tie', 'diet', 'tired', 'credit'],
  ['not', 'note', 'stone', 'honest'],
  ['sat', 'stay', 'nasty', 'sanity'],
  ['lap', 'pale', 'lapse', 'asleep'],
  ['tie', 'tied', 'tired', 'direct'],
  ['set', 'sent', 'stern', 'insert'],
  ['nor', 'horn', 'thorn', 'throne'],
  ['pan', 'plan', 'plane', 'planet'],
  ['red', 'read', 'drake', 'darker'],
  ['see', 'ease', 'tease', 'estate'],
  ['pat', 'tape', 'taped', 'update'],
  ['buy', 'bury', 'rugby', 'grubby'],
  ['tap', 'past', 'splat', 'postal'],
  ['end', 'dean', 'laden', 'handle'],
  ['air', 'liar', 'laird', 'lizard'],
  ['sea', 'sake', 'skate', 'staked'],
  ['led', 'lead', 'laden', 'landed'],
  ['let', 'felt', 'flute', 'fluent'],
  ['lad', 'deal', 'ideal', 'failed'],
  ['ice', 'eric', 'cider', 'direct'],
  ['row', 'worn', 'drown', 'onward'],
  ['sea', 'case', 'space', 'escape'],
  ['set', 'rest', 'reset', 'secret'],
  ['age', 'gear', 'grace', 'charge'],
  ['sit', 'spit', 'tipsy', 'pigsty'],
  ['red', 'dare', 'dread', 'raided'],
  ['tag', 'gate', 'stage', 'staged'],
  ['ace', 'care', 'clear', 'recall'],
  ['log', 'gold', 'lodge', 'golden'],
  ['hit', 'this', 'heist', 'ethics'],
  ['his', 'this', 'heist', 'ethics'],
  ['sea', 'sale', 'scale', 'clause'],
  ['sat', 'salt', 'atlas', 'astral'],
  ['tap', 'past', 'strap', 'pastry'],
  ['set', 'seat', 'tease', 'seated'],
  ['lab', 'able', 'table', 'battle'],
  ['are', 'earl', 'later', 'learnt'],
  ['ear', 'rage', 'barge', 'beggar'],
  ['set', 'west', 'waste', 'sweaty'],
  ['are', 'rare', 'racer', 'crater'],
  ['ear', 'read', 'dared', 'traded'],
  ['are', 'bare', 'baker', 'bakery'],
  ['ear', 'dare', 'padre', 'parked'],
  ['are', 'near', 'range', 'danger'],
  ['ear', 'race', 'raced', 'traced'],
  ['are', 'care', 'react', 'cartel'],
  ['are', 'fear', 'frame', 'farmer'],
  ['ear', 'care', 'react', 'crater'],
  ['are', 'tear', 'grate', 'garret'],
  ['ear', 'dare', 'bread', 'barred'],
  ['are', 'race', 'cedar', 'dancer'],
  ['ear', 'read', 'beard', 'badger'],
  ['are', 'rate', 'earth', 'rather'],
  ['ear', 'dear', 'heard', 'shared'],
  ['are', 'real', 'pearl', 'player'],
  ['ear', 'care', 'brace', 'breach'],
  ['are', 'dare', 'rated', 'traded'],
  ['ear', 'rate', 'stare', 'master'],
  ['are', 'wear', 'water', 'waiter'],
  ['ear', 'race', 'trace', 'cartel'],
  ['are', 'care', 'crane', 'cancer'],
  ['ear', 'hear', 'earth', 'rather'],
  ['are', 'fear', 'flare', 'falter'],
  ['ear', 'rate', 'treat', 'matter'],
  ['are', 'care', 'grace', 'charge'],
  ['ear', 'dare', 'rated', 'traded'],
  ['are', 'bear', 'rehab', 'breath'],
  ['ear', 'rate', 'earth', 'rather'],
  ['are', 'gear', 'barge', 'badger'],
  ['ear', 'earl', 'learn', 'rental'],
  ['are', 'bear', 'brave', 'beaver'],
  ['ear', 'gear', 'great', 'garret'],
  ['are', 'tear', 'mater', 'matter'],
  ['ear', 'care', 'racer', 'career'],
  ['are', 'tear', 'alter', 'taller'],
  ['ear', 'real', 'large', 'larger'],
  ['are', 'tear', 'stare', 'arrest'],
  ['ear', 'year', 'relay', 'nearly'],
  ['are', 'vera', 'raven', 'ravine'],
  ['ear', 'year', 'weary', 'sawyer'],
  ['are', 'race', 'crane', 'cancer'],
  ['ear', 'gear', 'range', 'german'],
  ['are', 'near', 'anger', 'german'],
  ['ear', 'wear', 'weary', 'lawyer'],
  ['are', 'dear', 'beard', 'barbed'],
  ['ear', 'race', 'trace', 'create'],
  ['are', 'race', 'trace', 'create'],
  ['ear', 'earn', 'learn', 'nearly'],
  ['are', 'tear', 'tread', 'thread'],
  ['ear', 'real', 'alter', 'learnt'],
  ['are', 'rate', 'crate', 'racket'],
];